<template>
    <div class="t-lk-modal__content">
        <h2 v-if="props.title" class="t-lk-modal__title">{{ props.title }}</h2>
        <h2 v-else class="t-lk-modal__title">{{ $root.staticText.lk.requestTitle }}</h2>

        <form-dynamic-cmp
            class="t-lk-modal__form"
            :form-info="form"
            :button="props.button"
            :class-white="false"
            :action="infoForm.action"
        >
        </form-dynamic-cmp>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import formDynamic from '@components/base/form-dynamic.vue';

    export default {
        name: "request",
        props: ['props'],
        data() {
            return {
                infoForm: {
                    action: "lk/requests/send",
                    disabledForm: false,
                    isPersonalData: false,
                    errorPersonalData: false,
                    success: false,
                    error: false,
                },
                form: {
                    "fields": [
                        {
                            "type": "form_field",
                            "content": {
                                "id": "title",
                                "title": this.$root.staticText.lk.requestTitle2,
                                "typeField": 1,
                                "requiredField": 1,
                                "description": null,
                                "hintField": this.$root.staticText.forms.placeholderCompany2,
                                "addClass": "_full-lk _right0",
                            }
                        },
                        // {
                        //     "type": "form_field",
                        //     "content": {
                        //         "id": "company",
                        //         "title": this.$root.staticText.forms.company3,
                        //         "typeField": 1,
                        //         "requiredField": 1,
                        //         "description": null,
                        //         "hintField": this.$root.staticText.forms.placeholderCompany
                        //     }
                        // },
                        // {
                        //     "type": "form_field",
                        //     "content": {
                        //         "id": "email",
                        //         "title": this.$root.staticText.forms.email,
                        //         "typeField": 4,
                        //         "requiredField": 1,
                        //         "description": null,
                        //         "hintField": this.$root.staticText.forms.placeholderEmail
                        //     }
                        // },
                        // {
                        //     "type": "form_field",
                        //     "content": {
                        //         "id": "phone",
                        //         "title": this.$root.staticText.forms.phone,
                        //         "typeField": 11,
                        //         "requiredField": 1,
                        //         "description": null,
                        //         "hintField": null
                        //     }
                        // },
                        {
                            "type": "form_field",
                            "content": {
                                "id": "typeId",
                                "title": this.$root.staticText.forms.typeRequest,
                                "typeField": 7,
                                "requiredField": 1,
                                "description": null,
                                "hintField": this.$root.staticText.forms.placeholderTypeRequest2,
                                "list": this.props.options,
                                "addClass": "_right",
                            }
                        },
                        {
                            "type": "form_field",
                            "content": {
                                "id": "comment",
                                "title": this.$root.staticText.forms.comment2,
                                "typeField": 2,
                                "requiredField": 1,
                                "description": null,
                                "hintField": null,
                                "addClass": "_right0",
                            }
                        },
                    ]
                }
            }
        },
        watch: {
            'infoForm.success': function() {
                if (this.infoForm.success) {
                    this.modalClose();
                    this.modalType_lkSuccessOpen({
                        title: this.$root.staticText.modal.successTitleFeedback,
                        text: this.$root.staticText.modal.successTextFeedback,
                        closeBthNone: true,
                    });
                }

            },
            'infoForm.error': function() {
                if (this.infoForm.error) {
                    this.modalClose();
                    this.modalType_lkErrorOpen({
                        title: this.$root.staticText.lk.lkErrorTitle,
                        text: this.$root.staticText.lk.lkErrorText,
                        closeBthNone: true,
                    });
                }
            }
        },
        components: {
            'form-dynamic-cmp': formDynamic,
        },
        computed: {
            ...mapGetters('lk', ['profile']),
        },
        methods: {
            ...mapActions('modal', ['modalType_lkSuccessOpen', 'modalType_lkErrorOpen', 'modalClose']),
        },
        // created() {
        //     this.form.fields.forEach(item => {
        //         switch (item.content.id) {
        //             case 'name':
        //                 item.content.value = (this.profile && (this.profile.name || this.profile.surname)) ?
        //                     this.profile.name + ' ' + this.profile.surname : null;
        //                 break;
        //             case 'company':
        //                 item.content.value = (this.profile && this.profile.company) ? this.profile.company : null;
        //                 break;
        //             case 'email':
        //                 item.content.value = (this.profile && this.profile.email) ? this.profile.email : null;
        //                 break;
        //             case 'phone':
        //                 item.content.value = (this.profile && this.profile.phone) ? this.profile.phone : null;
        //                 break;
        //         }
        //     })
        // }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/base/modals/request.vue